// Mock data for TSE OUEST website

export const companyInfo = {
  name: "TSE OUEST",
  tagline: "Électricité générale & Plâtrerie",
  phone: "0699134511",
  email: "contact@tseouest.com",
  address: "30 Boul. du Doyenné, 49100 Angers",
  city: "Angers",
  foundedYear: 2024,
  experience: 20,
  siret: "928 896 570 00019",
  tva: "FR02928896570",
  socialMedia: {
    instagram: "https://www.instagram.com/tseouest/",
    facebook: "https://www.facebook.com/profile.php?id=61568733483268",
    youtube: "https://www.youtube.com/@TSEOUEST"
  }
};

export const services = [
  {
    id: 1,
    title: "Électricité Générale",
    description: "Installation électrique complète, mise aux normes, dépannage et maintenance pour particuliers et professionnels.",
    icon: "Zap",
    features: [
      "Installation électrique neuve",
      "Mise aux normes NF C 15-100",
      "Dépannage électrique 7j/7",
      "Éclairage et domotique"
    ]
  },
  {
    id: 2,
    title: "Plâtrerie & Isolation",
    description: "Travaux de plâtrerie, pose de plaques de plâtre, joints et finitions pour une finition parfaite.",
    icon: "Layers",
    features: [
      "Pose de cloisons sèches",
      "Isolation thermique et phonique",
      "Plafonds suspendus",
      "Joints et finitions"
    ]
  }
];

export const portfolioImages = [
  {
    id: 29,
    url: "/assets/IMG_4421.webp",
    title: "Installation électrique professionnelle",
    category: "Électricité"
  },
  {
    id: 30,
    url: "/assets/IMG_4420.webp",
    title: "Tableau électrique moderne",
    category: "Électricité"
  },
  {
    id: 31,
    url: "/assets/IMG_4418.webp",
    title: "Câblage électrique avancé",
    category: "Électricité"
  },
  {
    id: 32,
    url: "/assets/IMG_4417.webp",
    title: "Installation électrique commerciale",
    category: "Rénovation"
  },
  {
    id: 33,
    url: "/assets/IMG_4415.webp",
    title: "Système électrique complet",
    category: "Électricité"
  },
  {
    id: 23,
    url: "/assets/maison-moderne-hero.png",
    title: "Villa moderne - Éclairage architectural complet",
    category: "Électricité"
  },
  {
    id: 24,
    url: "/assets/commercial1-tableau.webp",
    title: "Tableau électrique professionnel - Installation complexe",
    category: "Électricité"
  },
  {
    id: 25,
    url: "/assets/commercial2-restaurant1.webp",
    title: "Commerce - Plafond suspendu et éclairage LED sur rail",
    category: "Rénovation"
  },
  {
    id: 26,
    url: "/assets/commercial3-restaurant2.webp",
    title: "Restaurant moderne - Système d'éclairage complet",
    category: "Rénovation"
  },
  {
    id: 27,
    url: "/assets/commercial4-dream-team.webp",
    title: "S'IMPRIME - Aménagement commercial complet",
    category: "Rénovation"
  },
  {
    id: 28,
    url: "/assets/commercial5-overhead.webp",
    title: "Vue d'ensemble - Installation électrique et plafond",
    category: "Électricité"
  },
  {
    id: 1,
    url: "/assets/projet1.jpg",
    title: "Installation électrique et plâtrerie",
    category: "Électricité"
  },
  {
    id: 2,
    url: "/assets/projet2.jpg",
    title: "Cloisons sèches avec isolation",
    category: "Plâtrerie"
  },
  {
    id: 3,
    url: "/assets/projet3.jpg",
    title: "Pose de plaques de plâtre",
    category: "Plâtrerie"
  },
  {
    id: 4,
    url: "/assets/projet4.jpg",
    title: "Isolation et câblage électrique",
    category: "Rénovation"
  },
  {
    id: 5,
    url: "/assets/projet5.jpg",
    title: "Travaux de finition plâtrerie",
    category: "Plâtrerie"
  },
  {
    id: 6,
    url: "/assets/projet6.jpg",
    title: "Tableau électrique professionnel",
    category: "Électricité"
  },
  {
    id: 7,
    url: "/assets/projet7.jpg",
    title: "Installation tableau électrique extérieur",
    category: "Électricité"
  },
  {
    id: 8,
    url: "/assets/projet8.jpg",
    title: "Boîtier électrique avec connexions",
    category: "Électricité"
  },
  {
    id: 9,
    url: "/assets/projet9.jpg",
    title: "Tableau électrique complet intégré",
    category: "Électricité"
  },
  {
    id: 10,
    url: "/assets/projet10.jpg",
    title: "Plafond plâtre et câblage",
    category: "Rénovation"
  },
  {
    id: 12,
    url: "/assets/projet12.jpg",
    title: "Restaurant - Plafond suspendu et éclairage LED",
    category: "Rénovation"
  },
  {
    id: 13,
    url: "/assets/projet13.jpg",
    title: "Garage professionnel - Plafond et éclairage",
    category: "Rénovation"
  },
  {
    id: 14,
    url: "/assets/projet14.jpg",
    title: "Armoire électrique professionnelle",
    category: "Électricité"
  },
  {
    id: 16,
    url: "/assets/projet16.jpg",
    title: "Chambre - Plâtrerie et finitions",
    category: "Plâtrerie"
  },
  {
    id: 17,
    url: "/assets/projet17.jpg",
    title: "Maison moderne - Éclairage architectural LED",
    category: "Électricité"
  },
  {
    id: 18,
    url: "/assets/projet18.jpg",
    title: "Éclairage extérieur sur rail design",
    category: "Électricité"
  },
  {
    id: 19,
    url: "/assets/projet19.jpg",
    title: "Installation électrique complexe",
    category: "Électricité"
  },
  {
    id: 20,
    url: "/assets/projet20.jpg",
    title: "Tableau Linergy - Installation professionnelle",
    category: "Électricité"
  },
  {
    id: 21,
    url: "/assets/projet21.jpg",
    title: "Maison contemporaine - Éclairage façade LED",
    category: "Électricité"
  },
  {
    id: 22,
    url: "/assets/projet22.png",
    title: "Escalier - Éclairage LED intégré",
    category: "Électricité"
  },
  {
    id: 11,
    url: "https://images.unsplash.com/photo-1621905251918-48416bd8575a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwzfHxlbGVjdHJpY2FsJTIwaW5zdGFsbGF0aW9ufGVufDB8fHx8MTc3MTk3ODk3OHww&ixlib=rb-4.1.0&q=85",
    title: "Installation électrique moderne",
    category: "Électricité"
  }
];

export const guarantees = [
  {
    id: 1,
    title: "Respect des Normes",
    description: "Tous nos travaux respectent les normes en vigueur (NF C 15-100 pour l'électricité, DTU pour la plâtrerie)."
  },
  {
    id: 2,
    title: "Intervention Rapide",
    description: "Service de dépannage disponible 7j/7 pour répondre à vos urgences électriques."
  },
  {
    id: 3,
    title: "Qualité Professionnelle",
    description: "Une équipe qualifiée et expérimentée pour des travaux de haute qualité."
  },
  {
    id: 4,
    title: "Devis Gratuit",
    description: "Estimation précise et gratuite de vos travaux, sans engagement."
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "Les normes électriques NF C 15-100 en 2025",
    date: "15 janvier 2025",
    excerpt: "Découvrez les dernières évolutions de la norme électrique française et comment nous les appliquons dans nos installations.",
    image: "https://images.unsplash.com/photo-1565608438257-fac3c27beb36?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHw0fHxlbGVjdHJpY2FsJTIwaW5zdGFsbGF0aW9ufGVufDB8fHx8MTc3MTk3ODk3OHww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    title: "Isolation phonique : les meilleures techniques",
    date: "8 janvier 2025",
    excerpt: "Comment améliorer l'isolation phonique de votre logement avec des cloisons sèches adaptées.",
    image: "https://images.pexels.com/photos/5691657/pexels-photo-5691657.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: 3,
    title: "Domotique : modernisez votre installation électrique",
    date: "22 décembre 2024",
    excerpt: "Les solutions domotiques pour rendre votre maison plus intelligente et économe en énergie.",
    image: "https://images.pexels.com/photos/4756489/pexels-photo-4756489.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  }
];

export const references = [
  { id: 'spie', name: 'SPIE', logo: '/assets/logos/spie.svg' },
  { id: 'sipect', name: 'Sipect', logo: '/assets/logos/sipect.svg' },
  { id: 'eiffage', name: 'Eiffage', logo: '/assets/logos/eiffage.svg' },
  { id: 'podeliha', name: 'Podeliha', logo: '/assets/logos/podeliha.png' },
  { id: 'saumur-habitat', name: 'Saumur Habitat', logo: '/assets/logos/saumur-habitat.svg' },
  { id: 'meldomys', name: 'Meldomys', logo: '/assets/logos/meldomys.svg' },
  { id: 'mc-immo', name: 'MC IMMO', logo: '/assets/logos/mc-immo.png' }
];

export const testimonials = [
  {
    id: 1,
    name: "Marie Dupont",
    rating: 5,
    comment: "Excellent travail ! L'équipe de TSE OUEST a refait toute notre installation électrique. Professionnels et à l'écoute."
  },
  {
    id: 2,
    name: "Pierre Martin",
    rating: 5,
    comment: "Très satisfait des travaux de plâtrerie réalisés. Finitions impeccables et respect des délais."
  },
  {
    id: 3,
    name: "Sophie Leblanc",
    rating: 5,
    comment: "Je recommande vivement ! Intervention rapide pour un dépannage électrique urgent. Merci !"
  }
];